import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=d1564fb0&scoped=true"
import script from "./interface.vue?vue&type=script&lang=js"
export * from "./interface.vue?vue&type=script&lang=js"
import style0 from "./interface.vue?vue&type=style&index=0&id=d1564fb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1564fb0",
  null
  
)

export default component.exports